import * as React from "react"
import { SFProIcon, SFProIconProps } from "./SFProIcon"

export interface CheckCircleIconProps extends Omit<SFProIconProps, 'symbol'> {}

/**
 * Check Circle icon using SF Pro font symbol (􀉿)
 *
 * This icon represents success, completion, or registration,
 * used in the pairing help view to indicate successful product registration.
 *
 * @example
 * ```tsx
 * <CheckCircleIcon />
 * <CheckCircleIcon size={16} weight="bold" />
 * ```
 */
export const CheckCircleIcon = React.forwardRef<HTMLSpanElement, CheckCircleIconProps>(
  (props, ref) => {
    return <SFProIcon ref={ref} symbol="􀉿" {...props} />
  }
)

CheckCircleIcon.displayName = "CheckCircleIcon"
